import { CreateChannelApiKey } from '@/connection/channel/api-keys';
import { serializeError } from '@/store/utils/serialize-error';
import { ChannelSettingsReducerCreator } from '../types';

const createApiKeyReducer = (create: ChannelSettingsReducerCreator) => {
  return create.asyncThunk(async ({ channel }: { channel: number }, { rejectWithValue }) => {
    try {
      const apiKey = await CreateChannelApiKey(channel);
      return apiKey;
    } catch (error) {
      return rejectWithValue(serializeError(error));
    }
  });
};

export default createApiKeyReducer;
